const getDateSeparator = (dateString = '/') => {
  if (dateString.includes('/')) return '/'
  if (dateString.includes('-')) return '-'
  if (dateString.includes('.')) return '.'
  return '/'
}

export default getDateSeparator